import PolarisIcon from '@/components/_common/PolarisIcon';
import styled from '@emotion/styled';
import { Box, Divider, Grid, Skeleton, Typography } from '@mui/material';
import { selectActiveTitle, selectTitleLoading } from '../../../redux/selectors/titleSelectors';
import TabHeading from '../../_common/Tabs/TabHeading';
import { useAppSelector } from '@/redux/hooks';

const TitleDetailSynopsis = () => {
  const activeTitle = useAppSelector(selectActiveTitle);
  const isLoading = useAppSelector(selectTitleLoading);

  const renderSynopsisSection = (label: string, value: string | undefined) => (
    <Box component="section" sx={{ mb: 4 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        {label} Synopsis <PolarisIcon height={15} icon="curved_arrow_down" />
      </Typography>
      <Typography variant={!value ? 'caption' : 'body1'}>{value || '(none)'}</Typography>
    </Box>
  );

  return (
    <Synopsis>
      <Divider sx={{ mt: 4, mb: 5 }} />
      <TabHeading icon={<PolarisIcon icon="folded_paper" />}>Synopsis</TabHeading>

      {isLoading ? (
        <SkeletonWrapper container>
          <SkeletonItem item>
            <Skeleton width={'100%'} />
          </SkeletonItem>
          <SkeletonItem item>
            <Skeleton width={'75%'} />
          </SkeletonItem>
        </SkeletonWrapper>
      ) : (
        <>
          {activeTitle?.synopsis_short && renderSynopsisSection('Short', activeTitle.synopsis_short)}
          {activeTitle?.synopsis_long && renderSynopsisSection('Long', activeTitle.synopsis_long)}
          {renderSynopsisSection('Full', activeTitle?.synopsis)}
        </>
      )}
    </Synopsis>
  );
};

export default TitleDetailSynopsis;

const Synopsis = styled.div`
  margin-top: ${({ theme }) => theme.spacing(0)};
  white-space: pre-line;

  & svg {
    color: ${({ theme }) => theme.palette.primary.main};
  }

  & .MuiTypography-subtitle2 {
    font-size: 1rem;
    line-height: 1.7;
    display: flex;
    align-items: flex-end;
    white-space: pre-line;

    & svg {
      color: ${({ theme }) => theme.palette.default.main};
      margin-left: ${({ theme }) => theme.spacing(0.5)};
    }
  }
`;

const SkeletonWrapper = styled(Grid)`
  width: 100%;
`;

const SkeletonItem = styled(Grid)`
  padding-right: 48px;
  padding-bottom: 15px;
  width: 100%;
`;
